const saveDataToLocalStorage = (key, newData, callback) => {
    const storedData = JSON.parse(localStorage.getItem(key)) || [];
    const existingIndex = storedData.findIndex(item => item.question_id === newData.question_id);

    let updatedData;

    if (existingIndex !== -1) {
        updatedData = [
            ...storedData.slice(0, existingIndex),
            newData,
            ...storedData.slice(existingIndex + 1)
        ];
    } else {
        updatedData = [...storedData, newData];
    }

    setLocalStorage(key, updatedData);

    if (callback && typeof callback === 'function') {
        callback(updatedData);
    }
};


export const setLocalStorage = (key, updatedData) => {
    localStorage.setItem(key, JSON.stringify(updatedData));
};

export default saveDataToLocalStorage;